import React from "react";
import { useLocation } from "react-router";

function ConfirmPaidSubscriptionPage() {
  const { search } = useLocation();

  return (
    <div className="trial-view">
      we are creating your workspace... please wait
    </div>
  );
}

export { ConfirmPaidSubscriptionPage };
